import { render, staticRenderFns } from "./mails.write.vue?vue&type=template&id=56b8fac1&scoped=true&"
import script from "./mails.write.vue?vue&type=script&lang=js&"
export * from "./mails.write.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8fac1",
  null
  
)

export default component.exports